var exports = {
  "n": "ChartCardTitleHeading__sxSzmH",
};

module.exports = exports;
